import React from "react";
import "./index.css";
import Image from "next/image";
import { FolderIcon } from "@/utlility/icons";
import Link from "next/link";

const ServiceCard = ({
  image,
  title,
  parentCategory = null,
  parentSlug = null,
  slug = null,
  marketArea = null,
  childSlug = null,
  link = null,
  className = "",
  imageStyle = {},
  style = {}
}) => {
  return (
    <article className={`service-card ${className}`} style={style}>
      <div className={`image`} style={imageStyle}>
        {image && <Image src={image} alt={title || "Service"} width={272} height={172} />}
      </div>
      <h3 className="title fw-semibold">{title}</h3>
      {parentCategory && parentSlug && (
        <Link href={`${parentSlug}-in-${marketArea?.slug}`} className="category-link">

          <FolderIcon className="text-primary me-2" />
          <span>{parentCategory}</span>

        </Link>
      )}
      <Link
        href={link ? link :
          parentCategory
            ? `${childSlug}-in-${marketArea?.slug}`
            : `${slug}-in-${marketArea}`
        }
        className="service-card-btn w-100 d-inline-block text-center rounded-pill fw-medium"
        aria-label={`See details for ${slug}-in-${marketArea}`}
      >
        See Details
      </Link>
    </article>
  );
};

export default ServiceCard;
